import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'decodeHtmlString' })
export class DecodeHtmlStringPipe implements PipeTransform {
  transform(value: string | number) {
    // Decode HTML entities without an innerHTML sink (avoids DOM-based XSS).
    const parsed = new DOMParser().parseFromString(value.toString(), 'text/html');
    return parsed.documentElement.textContent ?? '';
  }
}
